import { Suspense, lazy } from "react";

/**
 * Dev-only entry point for the tuner.
 *
 * The panel and its stylesheet live behind a dynamic import so that a
 * production build carries neither. `import.meta.env.DEV` is a compile-time
 * constant, so the branch — and with it the whole chunk — is dropped.
 */
const TunerPanel = import.meta.env.DEV
  ? lazy(() => import("./TunerPanel.js"))
  : null;

export function Tuner() {
  if (!TunerPanel) return null;
  return (
    <Suspense fallback={null}>
      <TunerPanel />
    </Suspense>
  );
}
